import { t } from "@web-monorepo/i18n/macro";
import createAction from "@web-monorepo/infra/createAction";
import { getImageSrc } from "@web-monorepo/static-assets";
import { AppMetadata } from "src/pods/toolkitData/components/EditableSetup";
import { Question } from "./types";

const icon = getImageSrc("toolkit/src/pods/pairshare/assets/logo.svg");

export const appMetadataPairshare = (): AppMetadata => ({
  href: "pairshare",
  title: t`Think Pair Share`,
  variant: "pairshare",
  icon,
});

export const RECEIVE_QUESTION = createAction("RECEIVE_QUESTION");

export type PairShareState = {
  question?: Question;
};
